import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';
import type { HttpShippingOptionDraft } from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';

const updateShippingOption = (
  repository: CartRepository,
  deliveryGroupId: string,
  shippingOptionDraft: HttpShippingOptionDraft
): Promise<Cart> => {
  return repository.updateShippingOption(deliveryGroupId, shippingOptionDraft);
};

export default updateShippingOption;
